import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { CargoType } from 'types';
import CargosStore from 'stores/CargosStore';
import IconSVG from 'svg-inline-react';
import { translate as t } from 'lang';

class DeliveryCargos extends Component {

    static propTypes = {
        onRemoveCargo: PropTypes.func,
        onEditCargo: PropTypes.func,
    };

    getCargoElement(element) {
        var $cargo = $(element);

        if (!$cargo.is('.delivery-cargo')) $cargo = $cargo.parents('.delivery-cargo').first();
        if (!$cargo.is('.delivery-cargo')) return null;
        return $cargo;
    }

    constructor(props) {
        super(props);
    }

    /**
     * @param {CargoType} cargoType
     * @return {Object}
     */
    renderCargo = (cargoType, index) => {

        var cargoId = cargoType.id || cargoType.stuff_type_id;

        var cargoProps = {
            key: index,
            "data-cargo-id": cargoId,
            "data-cargo-index": index,
            className: classNames('delivery-cargo')
        };

        var name = cargoType.getIn(['attributes', 'name', 'value'], cargoType.name);

        return (
            <div {...cargoProps}>
                <div onClick={this.handlerEditCargo} className="delivery-cargo__name">
                    { name }: { cargoType.getIn(['attributes', 'quantity', 'value'], 1) }
                </div>
                <div className="delivery-cargo-edit" onClick={this.handlerEditCargo}>
                    <IconSVG className="delivery-cargo-edit__icon"
                             src={require('!svg-inline!./pen.svg')}
                             title="Отредактировать груз"/>
                </div>
                <div className="delivery-cargo-delete" onClick={ this.handlerRemoveCargo }>
                    <IconSVG className="delivery-cargo-delete__icon"
                             src={require('!svg-inline!./delete.svg')}
                             title="Удалить груз"/>
                </div>
            </div>
        );
    };

    render() {
        var content = '';
        var classes = '';

        var deliveryCargos = CargosStore.getDeliveryCargos();
        if (deliveryCargos.size > 0) {
            classes = 'delivery';
            content = deliveryCargos.map(this.renderCargo);
        } else {
            classes = classNames('delivery', 'delivery--info');
            content = <div className="delivery-infoText">{t('HERE_YOU_WILL_SEE_YOUR_STUFF')}</div>
        }

        return (
            <div className={classes}>
                { content }
            </div>
        );
    }

    handlerRemoveCargo = (event) => {
        event.stopPropagation();

        var $cargo = this.getCargoElement(event.target);
        var cargoId = $cargo.data('cargo-index');

        if (cargoId < 0) {
            return;
        }

        if (this.props.onRemoveCargo) {
            this.props.onRemoveCargo(cargoId);
        }
    }

    handlerEditCargo = (event) => {
        var $cargo = this.getCargoElement(event.target);
        var cargoIndex = $cargo.data('cargo-index');
        var cargo = CargosStore.getDeliveryCargoByIndex(cargoIndex);

        if (this.props.onEditCargo) {
            this.props.onEditCargo(cargo, cargoIndex);
        }
    }
}

module.exports = DeliveryCargos;


// WEBPACK FOOTER //
// ./client/components/Categories/Moving/DeliveryCargos.js